export default class IconController {
	/* @ngInject */
	/**
	 * @param {import('angular').translate.ITranslateService} $translate
	 */
	constructor($translate) {
		this.$translate = $translate;
		this.src = undefined;
		this.name = undefined;
	}

	/**
	 * @param {import('angular').IOnChangesObject} changes
	 */
	$onChanges(changes) {
		if (changes.mimetype && changes.mimetype.currentValue) {
			this.src = `/images/icons/${changes.mimetype.currentValue.replace('/', '-')}.png`;
			this.name = this.$translate.instant(`mimetype.${changes.mimetype.currentValue}`);
		}
		else {
			this.src = '/images/icons/unknown.png';
			this.name = '?';
		}
	}
}
